export type AutoLearningGameMode = 'Pick' | 'Type';

// Pick is the user-facing WordBuilding mode. Change this to Type for Input.
export const AUTO_LEARNING_GAME_MODE: AutoLearningGameMode = 'Pick';
